/*---------------------------------------------------------------
 *
 *	This component displays an input item that allows users to 
 *	increase or decrease the `order` for the <Graph/>
 *
 * --------------------------------------------------------------
 */

import React from "react";

export interface OrderGraphs {
	order_graph_1: number;
  }
  
  interface Props extends OrderGraphs {
	setOrders(graphs: Partial<OrderGraphs>): void;
  }
export default class OrderChanger extends React.Component<Props> {
	renderInput(property: keyof OrderGraphs, label: string) {
	  return (
		<div className="col-6">
		  <p className="text-center">{label}</p>
		  <div className="w-100 d-flex justify-content-center">
			<input
			  className="text-center"
			  name={property}
			  type="number"
			  value={this.props[property]}
			  onChange={(e) =>
				this.props.setOrders({ [property]: parseInt(e.target.value, 10) })
			  }
			  min="1"
			  max="10"
			  step="1"
			/>
		  </div>
		</div>
	  );
	}
  
	render() {
	  return (
		<div className="row">
		  {this.renderInput("order_graph_1", "Order/Degree of the Model: ")}
		</div>
	  );
	}
  }

